export default __webpack_public_path__ + "static/applet-16-set-1-44d61578f88ada7c78420285b296f315.webp";